export function withTimeout(promise, ms, errorMessage = 'La operación no respondió a tiempo.') {
  return Promise.race([
    promise,
    new Promise((_, reject) => {
      setTimeout(() => {
        const t = new Error(errorMessage);
        t.code = 'deadline-exceeded';
        reject(t);
      }, ms);
    }),
  ]);
}
